import { Collider } from "@wonderlandengine/api";
import { CursorTarget } from "@wonderlandengine/components";

export const POINTER_INTERACTION_GROUP_MASK = (1 << 0) | (1 << 1);
export const DEFAULT_SELECT_DEBOUNCE_MS = 180;

export function ensureInteractable(
  object,
  {
    extents,
    group = POINTER_INTERACTION_GROUP_MASK,
    collider = Collider.Box,
    active = true,
  } = {},
) {
  if (!object) return { collision: null, target: null };

  let collision = object.getComponent("collision");
  if (!collision) collision = object.addComponent("collision");
  collision.collider = collider;
  collision.group = group;
  if (extents) collision.extents = new Float32Array(extents);
  collision.active = active;

  let target = object.getComponent(CursorTarget);
  if (!target) target = object.addComponent(CursorTarget);

  return { collision, target };
}

export function addStablePointerSelect(
  target,
  callback,
  { debounceMs = DEFAULT_SELECT_DEBOUNCE_MS } = {},
) {
  if (!target || !callback) return null;

  let lastSelectTime = -Infinity;
  const trigger = (...args) => {
    const now =
      typeof performance !== "undefined" && performance.now
        ? performance.now()
        : Date.now();
    if (now - lastSelectTime < debounceMs) return;
    lastSelectTime = now;
    callback(...args);
  };

  target.onDown.add(trigger);
  target.onClick.add(trigger);
  return trigger;
}
